import React, { Component } from 'react';
import PropTypes from 'prop-types'
import AuthService from '../lib/AuthService';
import i18n from 'i18next';

import localStore from '../lib/LocalStore';

export default function withAuth(AuthComponent) {
	const Auth = new AuthService();
	let loginInterval = null;

	class AuthWrapped extends Component {
		state = {
		  loggedIn: null,
		};

		componentWillMount() {
		  const { language } = i18n;
		  const loginPath = '/' + language + '/t/login/';

		  if (!Auth.loggedIn()) {
		    const { pathname } = window.location;
		    const passwordPage = pathname.indexOf('password') !== -1;
		    const loginPage = pathname.indexOf('login') !== -1;

		    if (!loginPage) {
		      console.log('[withAuth.js]', 'Not logged in. Storing requested url as: ', pathname);
		      localStore.set({ loggedOutFrom: pathname });
		    }

		    if (!passwordPage) {
		      this.props.history.replace(loginPath);
		    }

		  } else {
		    try {
		      const profile = Auth.getProfile();

		      this.setState({
		        loggedIn: profile
		      });

		    } catch(err){
		      Auth.logout();
		      this.props.history.replace(loginPath);
		    }
		  }
		}

		componentDidMount() {
		  const { language } = i18n;
		  const loginPath = '/' + language + '/t/login/';

		  loginInterval = setInterval(() => {
		    const loggedIn = Auth.loggedIn();

		    if (!loggedIn) {

		      console.log('[withAuth.js] Logging out...');
		      clearInterval(loginInterval);

		      const { pathname } = window.location;
		      const inApp = pathname.indexOf('login') === -1 && pathname.indexOf('password') === -1;

		      if (inApp) {

		        localStore.set({ loggedOutFrom: window.location.pathname });
		        console.log('[withAuth.js]', 'loggedOutFrom', window.location.pathname);

		        this.props.history.replace(loginPath);

		      }
		    }
		  }, 10000);
		}

		componentWillUnmount() {
		  clearInterval(loginInterval);
		}

		componentWillReceiveProps() {
		  this.setState({
		    loggedIn: Auth.loggedIn() ? Auth.getProfile() : null
		  });
		}

		render() {
		  return this.state.loggedIn ? <AuthComponent {...this.props} /> : null;
		}

	}

	AuthWrapped.propTypes = {
		history: PropTypes.object,
	}

	return AuthWrapped;

}
